import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

/**
 * Glass navigation header with auth links.
 */
export function LandingNavigation() {
  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50"
    >
      <div className="mx-auto max-w-7xl px-6 py-4">
        <div className="flex items-center justify-between rounded-2xl bg-white/70 backdrop-blur-xl border border-gray-200/50 shadow-lg shadow-gray-200/20 px-6 py-3">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="/vrmeet_logo.png"
              alt="VR Meet"
              className="h-10 w-10 object-contain transition-transform group-hover:scale-105"
            />
            <span className="text-xl font-semibold bg-gradient-to-r from-brand-blue via-brand-teal to-brand-green bg-clip-text text-transparent">
              VR Meet
            </span>
          </Link>

          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="px-5 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
            >
              Log in
            </Link>
            <Link
              to="/register"
              className="px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-brand-blue via-brand-teal to-brand-green rounded-xl hover:opacity-90 transition-all hover:shadow-lg hover:shadow-brand-teal/25"
            >
              Sign up
            </Link>
          </div>
        </div>
      </div>
    </motion.nav>
  );
}
